/* =========================================================
   INKSOFT PRODUCT UTILS MODULE
   Shared utility helpers for InkSoft product page modules
========================================================= */

window.InksoftPOC = window.InksoftPOC || {};

window.InksoftPOC.productUtils = (function () {
  function asArray(value) {
    return Array.isArray(value) ? value : [];
  }

  function asString(value) {
    return value == null ? '' : String(value).trim();
  }

  function firstNonEmpty() {
    for (let i = 0; i < arguments.length; i += 1) {
      const value = asString(arguments[i]);
      if (value) return value;
    }

    return '';
  }

  function normalizeInksoftUrl(url) {
    let value = asString(url);

    if (!value) return '';

    value = value.replace(
      /\/Unisource_Apparel\/Unisource_Apparel\//g,
      '/Unisource_Apparel/'
    );

    if (/^https?:\/\//i.test(value)) return value;

    if (value.indexOf('/Unisource_Apparel/') === 0) {
      return 'https://shop.unisourceapparel.com' + value;
    }

    if (value.indexOf('/images/') === 0) {
      return 'https://shop.unisourceapparel.com/Unisource_Apparel' + value;
    }

    if (value.indexOf('/JITImage/') === 0) {
      return 'https://shop.unisourceapparel.com/Unisource_Apparel' + value;
    }

    return value;
  }

  function isPdfUrl(url) {
    return /\.pdf(?:\?|#|$)/i.test(asString(url));
  }

  function isImageUrl(url) {
    return /\.(png|jpe?g|gif|webp|svg)(?:\?|#|$)/i.test(asString(url));
  }

  function isJitImageUrl(url) {
    return /\/JITImage\//i.test(asString(url));
  }

  function sanitizeHex(value) {
    const raw = asString(value).replace(/^#/, '').trim();

    if (/^[A-Fa-f0-9]{6}$/.test(raw)) {
      return raw.toUpperCase();
    }

    if (/^[A-Fa-f0-9]{3}$/.test(raw)) {
      return raw
        .split('')
        .map(function (c) {
          return c + c;
        })
        .join('')
        .toUpperCase();
    }

    return '';
  }

  return {
    asArray: asArray,
    asString: asString,
    firstNonEmpty: firstNonEmpty,
    normalizeInksoftUrl: normalizeInksoftUrl,
    isPdfUrl: isPdfUrl,
    isImageUrl: isImageUrl,
    isJitImageUrl: isJitImageUrl,
    sanitizeHex: sanitizeHex
  };
})();